module.exports = __webpack_public_path__ + "static/media/TeresaOliveira.910f1410.png";